import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState';

const activeSlice = createSlice({
  name: 'active',
  initialState,
  reducers: {
    setOrganizationUserProfile: (state, action) => {
      state.selectedItem.organization_user_profile =
        action.payload.organization_user_profile;
    },
    setRedirectToInvitation: (state, action) => {
      state.redirectToInvitation = action.payload.redirectToInvitation;
    },
    setOrganizationAccess: (state, action) => {
      state.selectedItem.organizationAccess = action.payload.organizationAccess;
    },
    setAssetUrl: (state, action) => {
      state.selectedItem.assetUrl = action.payload.assetUrl;
    },
    reset: (state, action) => {
      state.selectedItem = action.payload.selectedItem;
      state.redirectToInvitation = action.payload.redirectToInvitation;
    },
  },
});

export const {
  reset,
  setOrganizationUserProfile,
  setRedirectToInvitation,
  setOrganizationAccess,
  setAssetUrl,
} = activeSlice.actions;
export default activeSlice.reducer;
